import { FaExclamationCircle } from 'react-icons/fa';
import TextareaComponent from '../../components/TextareaComponent';

// SCSS
import '../../assets/scss/sectionSeven.scss';

const SectionSeven = ({ register, formData, sending }) => {
	return (
		<div className='sectionSeven'>
			<div className='header'>
				<h2>Ekstra informasjon</h2>
				<small className='field-description-text'>
					Legg til ekstra informasjon om kampanjeperioden, private
					profiler og bannerannonsering
				</small>
			</div>

			<div className='flex-row'>
				<div className='flex-col'>
					<TextareaComponent
						label='Ønsker om kampanjeperiode og annen info'
						name='kampanjeperiode'
						className='kampanjeperiode'
						placeholder='Skriv inn ønske om kampanjeperiode'
						cols='40'
						rows='4'
						register={register}
					/>
					<small className='field-description-text'>
						Spesielle ønsker om kampanjeperiode? <br />
						(Oppstart er normalt 2 virkedager fra bestilling, før kl
						09:00)
						<FaExclamationCircle size='22' />
					</small>
				</div>
				{formData.packageChoice !== 'Basis' && (
					<div className='flex-col'>
						<TextareaComponent
							label='Innlegg til story private profiler'
							name='storyText'
							className='story-text'
							placeholder='Skriv tekst til innlegg for story til private profiler i SOME'
							cols='40'
							rows='4'
							register={register}
						/>
						<small className='field-description-text'>
							Konsulenter i ADA kan velge å legge utvalgte stillinger
							på egne storier på facebook og insta, og da må dette
							sendes over fra Polaris media. <br />
							Skriv her dersom slikt innlegg ønskes.
							<FaExclamationCircle size='22' />
						</small>
					</div>
				)}

			</div>

			<div style={{ height: '1px', backgroundColor: '#00000050', margin: '40px 0', width: '100%' }}></div>


			<input
				type='submit'
				value={sending ? 'Sender....' : 'Send bestilling'}
				disabled={sending}
			/>
		</div>
	);
};

export default SectionSeven;
